import { createPortal } from "react-dom";
import { ParentComponentProps } from "@/interfaces/common";

export const Portal = ({ children }: ParentComponentProps): JSX.Element => {
  return createPortal(children, document.body);
};
